import type { History } from '~/core/router'

import { createEvent, sample } from 'effector'
import { dom, model as router } from '~/core/router'
import { model as sse } from '~/core/sse'
import { analytix, jail, launch, navigation, routing, sw } from '~/processes'
import { noop } from '~/shared/helpers'

// init application
export const init = createEvent<{
  history: History
  container: HTMLElement
}>()

// init router model at application init
sample({
  clock: init,
  fn: ({ history }) => ({ history, routes: routing.route }),
  target: router.init,
})

// init dom model at application init
sample({
  clock: init,
  fn: ({ container }) => ({ container }),
  target: dom.init,
})

// init SSE at application init
sample({
  clock: init,
  fn: noop,
  target: sse.init,
})

// init service worker at application init
sample({
  clock: init,
  fn: noop,
  target: sw.init,
})

// init application navigation process
sample({
  clock: init,
  fn: noop,
  target: [jail.init, navigation.init, routing.init],
})

// init application launch process
sample({
  clock: init,
  fn: noop,
  target: launch.init,
})

// init analytics process
sample({
  clock: init,
  fn: noop,
  target: analytix.init,
})

//
// handlers for external usages
//

export const onLocationChange = navigation.renderFx.use
